import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/UI/Breadcrumbs/Breadcrumbs.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/app/projects/staffpower-multilingual-recruitment-website-development/page.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/node_modules/next/dist/client/image-component.js");
